export const isExternal = (url: string): boolean => /^(https?:)?\/\//.test(url);
